import { useAppSelector } from "src/app/hooks";
import styles from "./Index.module.css";

function ACHInfo() {
  const { acctName, acctId } = useAppSelector((state) => state.auth);

  return (
    <div className={styles.container}>
      <div className="card">
        <div className="card-header">
          <i className="bi bi-bank me-2"></i>
          ACH Payment Information
        </div>
        <div className="card-body">
          <p className={styles.intro}>
            Use the following information to send ACH payments to Contact Center
            Compliance.
          </p>

          <div className={styles.section}>
            <h2 className={styles.sectionHeader}>
              <i className="bi bi-building me-2"></i>
              Bank Information
            </h2>
            <div className={styles.infoBlock}>
              <div className={styles.infoRow}>
                <span className={styles.label}>Bank Name:</span>
                <span className={styles.value}>Columbia Bank</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>Address:</span>
                <span className={styles.value}>
                  801 Fourth St.
                  <br />
                  Santa Rosa, CA 95404
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>ABA Routing #:</span>
                <span className={`${styles.value} ${styles.mono}`}>
                  123205054
                </span>
              </div>
            </div>
          </div>

          <div className={styles.section}>
            <h2 className={styles.sectionHeader}>
              <i className="bi bi-person-badge me-2"></i>
              Account Information
            </h2>
            <div className={styles.infoBlock}>
              <div className={styles.infoRow}>
                <span className={styles.label}>Account Name:</span>
                <span className={styles.value}>Contact Center Compliance</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>Address:</span>
                <span className={styles.value}>
                  350 E Street
                  <br />
                  Santa Rosa, CA 95404
                </span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>Account #:</span>
                <span className={`${styles.value} ${styles.mono}`}>
                  4862468834
                </span>
              </div>
            </div>
          </div>

          <div className={styles.customerSection}>
            <h2 className={styles.sectionHeader}>
              <i className="bi bi-briefcase me-2"></i>
              Your Account
            </h2>
            <div className={styles.customerBlock}>
              <div className={styles.infoRow}>
                <span className={styles.label}>Account Name:</span>
                <span className={styles.value}>{acctName}</span>
              </div>
              <div className={styles.infoRow}>
                <span className={styles.label}>Account ID:</span>
                <span className={`${styles.value} ${styles.mono}`}>
                  {acctId}
                </span>
              </div>
            </div>
          </div>

          <div className={styles.note}>
            <i className="bi bi-info-circle me-2"></i>
            Please include your invoice number in the payment memo for proper
            credit.
          </div>

          <div className={styles.documentLink}>
            <a
              href="/docs/Columbia Bank Letter.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="bi bi-file-earmark-pdf me-2"></i>
              Download Bank Letter on Official Letterhead (PDF)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ACHInfo;
